import * as React from 'react';
import PropTypes from 'prop-types';
import { StyledLabelContainer, StyledSlider } from './RangeSlider.styles.js';
import { Box } from '@mui/material';

/* eslint-disable */
const RangeSlider = _ref => {
  let {
    values,
    onChange,
    min,
    step,
    max,
    minText,
    maxText
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(StyledLabelContainer, null, /*#__PURE__*/React.createElement(Box, null, minText), /*#__PURE__*/React.createElement(Box, null, maxText)), /*#__PURE__*/React.createElement(StyledSlider, {
    value: values,
    onChange: onChange,
    min: min,
    step: step,
    max: max
  }));
};
RangeSlider.propTypes = {
  values: PropTypes.shape({}),
  onChange: PropTypes.func,
  min: PropTypes.number,
  step: PropTypes.number,
  max: PropTypes.number,
  minText: PropTypes.string,
  maxText: PropTypes.string
};
RangeSlider.defaultProps = {
  values: [0, 100],
  onChange: () => {},
  min: 0,
  max: 100,
  step: 1,
  minText: 'min',
  maxText: 'max'
};
var RangeSlider$1 = RangeSlider;
export { RangeSlider$1 as default };